import React, { useEffect, useState } from 'react'

export default function Usuarios(props) {
    const [firstName, setFirstName] = useState('')
    const [secondName, setSecondtName] = useState('')
    const [apellido, setApellido] = useState('')
    const [nombreUsuario, setNombreUsuario] = useState('')
    const [correo, setCorreo] = useState('')
    const [tipoIdentificacion, setTipoIdentificacion] = useState('')
    const [numeroIdentificacion, setNumeroIdentificacion] = useState('')
    const [personalSanitario, setPersonalSanitario] = useState('')
    const [telefono, setTelefono] = useState('')
    const [nacionalidad, setNacionalidad] = useState('')
    const [fechaNacimiento, setFechaNacimiento] = useState('')
    const [area, setArea] = useState('')
    const [roles, setRoles] = useState('')
    const [estado, setEstado] = useState('')
    const [sexo, setSexo] = useState('')
    const [inputValue, setInputValue] = useState('')
    const [coincidencias, setCoincidencias] = useState([])

    const usuariosEjemplo = [
        'Juan Pérez',
        'Ana Gómez',
        'Pedro López',
        'María Fernández',
        'Laura Sánchez',
        'Jorge Díaz',
        'Lucía Martínez',
        'Carlos Ruiz',
    ]

    useEffect(() => {
        if (props.formData.data) {
            const datForm = props.formData.data
            setFirstName(datForm["primerNombre"])
            setSecondtName(datForm["segundoNombre"])
            setApellido(datForm["primerApellido"])
            setNombreUsuario(datForm["codigoUsuario"])
            setCorreo(datForm["correoElectronico"])
            setTipoIdentificacion(datForm["codigoTipoIdentificacion"])
            setNumeroIdentificacion(datForm["numeroIdentificacion"])
            setPersonalSanitario(datForm["esPersonalSanitario"])
            setTelefono(datForm["telefono"] ?? '')
            setNacionalidad(datForm["codigoPaisNacionalidad"])
            const [day, month, year] = datForm["fechaNacimiento"].split("/");
            // Convierte la fecha de DD/MM/YYYY a YYYY-MM-DD
            const formattedDate = `${year}-${month}-${day}`;
            setFechaNacimiento(formattedDate);
            //setFechaNacimiento(datForm["fechaNacimiento"])
            setArea(datForm["area"] ?? '')
            setRoles(datForm["roles"] ?? '')
            setEstado(datForm["esActivo"] ?? '')
            setSexo(datForm["sexo"])
        } else {
            setFirstName(localStorage.getItem("firstName"))
            setSecondtName(localStorage.getItem("secondName"))
            setApellido(localStorage.getItem("apellido"))
            setNombreUsuario(localStorage.getItem("nombreUsuario"))
            setCorreo(localStorage.getItem("correo"))
            setTipoIdentificacion(localStorage.getItem("tipoIdentificacion"))
            setNumeroIdentificacion(localStorage.getItem("numeroIdentificacion"))
            setPersonalSanitario(localStorage.getItem("personalSanitario"))
            setTelefono(localStorage.getItem("telefono"))
            setNacionalidad(localStorage.getItem("nacionalidad"))
            setFechaNacimiento(localStorage.getItem("fechaNacimiento"))
            setArea(localStorage.getItem("area"))
            setRoles(localStorage.getItem("roles"))
            setEstado(localStorage.getItem("estado"))
            setSexo(localStorage.getItem("sexo"))
        }
    }, [props])

    const handleInputChange = (e) => {
        const value = e.target.value
        setInputValue(value)

        // Filtrar nombres que contengan el texto ingresado
        if (value) {
            const coincidenciasFiltradas = usuariosEjemplo.filter(nombre =>
                nombre.toLowerCase().includes(value.toLowerCase())
            )
            setCoincidencias(coincidenciasFiltradas)
        } else {
            setCoincidencias([]) // Limpiar coincidencias si el input está vacío
        }
    }

    const handleSelectCoincidencia = (nombre) => {
        setInputValue(nombre)
        setCoincidencias([])
    }

    return (
        <div className="row justify-content-center">

            {/* Campo de búsqueda */}
            {/*<div className="col-6">
                <div className="form-group position-relative">
                    
                    {/* <label className="custom-label">Por favor buscar o ingresar datos para crear el usuario</label><input
                        type="text"
                        className="form-control custom-input"
                        placeholder="Buscar"
                        value={inputValue}
                        onChange={handleInputChange}
                    />
                    <span className="search-icon" style={{ position: 'absolute', right: '10px', top: '70%', transform: 'translateY(-50%)' }}>
                        <i className='fas fa-search' style={{ fontSize: '25px', color: 'lightblue' }}></i>
    </span>}
                    {coincidencias.length > 0 && (
                        <ul className="list-group position-absolute" style={{ zIndex: 1000, width: '100%', marginTop: '4.5rem' }}>
                            {coincidencias.map((nombre, index) => (
                                <li
                                    key={index}
                                    className="list-group-item"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleSelectCoincidencia(nombre)}
                                >
                                    {nombre}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>*/}
            <div className="card-body">
                <div className="row">

                    {/* Primer Nombre */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Primer Nombre</label>
                            <input
                                disabled
                                id="firstName"
                                name="firstName"
                                type="text"
                                maxLength={50}
                                value={firstName}
                                onChange={e => {
                                    setFirstName(e.target.value.replace(/[^a-z\s]/gi, ''))
                                    localStorage.setItem('firstName', e.target.value.replace(/[^a-z\s]/gi, ''))
                                }}
                                className="form-control"
                                placeholder="Ingresar primer nombre"
                            />
                        </div>
                    </div>

                    {/* Segundo Nombre */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Segundo Nombre</label>
                            <input
                                disabled
                                id="secondName"
                                name="secondName"
                                type="text"
                                maxLength={50}
                                value={secondName}
                                onChange={e => {
                                    setSecondtName(e.target.value.replace(/[^a-z\s]/gi, ''))
                                    localStorage.setItem('secondName', e.target.value.replace(/[^a-z\s]/gi, ''))
                                }}
                                className="form-control"
                                placeholder="Ingresar Segundo Nombre"
                            />
                        </div>
                    </div>

                    {/* Apellido */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Apellidos</label>
                            <input
                                disabled
                                id="apellido"
                                name="apellido"
                                type="text"
                                maxLength={50}
                                value={apellido}
                                onChange={e => {
                                    setApellido(e.target.value.replace(/[^a-z\s]/gi, ''))
                                    localStorage.setItem('apellido', e.target.value.replace(/[^a-z\s]/gi, ''))
                                }}
                                className="form-control"
                                placeholder="Ingresar Apellidos"
                            />
                        </div>
                    </div>

                    {/* Nombre de Usuario */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Nombre de Usuario</label>
                            <input
                                disabled
                                id="nombreUsuario"
                                name="nombreUsuario"
                                type="text"
                                maxLength={50}
                                value={nombreUsuario}
                                onChange={e => {
                                    setNombreUsuario(e.target.value.replace(/[^a-z\s]/gi, ''))
                                    localStorage.setItem('nombreUsuario', e.target.value.replace(/[^a-z\s]/gi, ''))
                                }}
                                className="form-control"
                                placeholder="Ingresar Nombre de Usuario"
                            />
                        </div>
                    </div>

                    {/* Correo Electrónico */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Correo Electrónico</label>
                            <input
                                disabled
                                id="correo"
                                name="correo"
                                type="text"
                                maxLength={50}
                                value={correo}
                                onChange={e => {
                                    setCorreo(e.target.value.replace(/[^a-z\s]/gi, ''))
                                    localStorage.setItem('correo', e.target.value.replace(/[^a-z\s]/gi, ''))
                                }}
                                className="form-control"
                                placeholder="Ingresar Correo@example.com"
                            />
                        </div>
                    </div>

                    {/* Sexo */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Sexo</label>
                            <select className="form-control" disabled value={sexo}>
                                <option value="">Seleccionar</option>
                                <option value="M">Hombre</option>
                                <option value="F">Mujer</option>
                            </select>
                        </div>
                    </div>

                    {/* Tipo de Identificación */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Tipo de Identificación</label>
                            <select className="form-control" disabled value={tipoIdentificacion}>
                                <option value="">Seleccionar</option>
                                <option value="1">Ruc</option>
                                <option value="2">Cédula</option>
                                <option value="3">Pasaporte</option>
                            </select>
                        </div>
                    </div>

                    {/* Número de Identificación */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Número de Identificación</label>
                            <input
                                disabled
                                id="numeroIdentificacion"
                                name="numeroIdentificacion"
                                type="text"
                                maxLength={50}
                                value={numeroIdentificacion}
                                onChange={e => {
                                    setNumeroIdentificacion(e.target.value.replace(/[^a-z\s]/gi, ''))
                                    localStorage.setItem('numeroIdentificacion', e.target.value.replace(/[^a-z\s]/gi, ''))
                                }}
                                className="form-control"
                                placeholder="Ingresar Número de Identificación"
                            />
                        </div>
                    </div>

                    {/* Personal Sanitario */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Personal sanitario</label>
                            <select className="form-control" disabled value={personalSanitario}>
                                <option value="">Seleccionar</option>
                                <option value="S">Si</option>
                                <option value="N">No</option>
                            </select>
                        </div>
                    </div>

                    {/* Teléfono */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Teléfono</label>
                            <input
                                disabled
                                id="telefono"
                                name="telefono"
                                type="text"
                                maxLength={50}
                                value={telefono}
                                onChange={e => {
                                    setTelefono(e.target.value.replace(/[^a-z\s]/gi, ''))
                                    localStorage.setItem('telefono', e.target.value.replace(/[^a-z\s]/gi, ''))
                                }}
                                className="form-control"
                                placeholder="Ingresar Teléfono +593 999999999"
                            />
                        </div>
                    </div>

                    {/* Nacionalidad */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Nacionalidad</label>
                            <select className="form-control" disabled value={nacionalidad}>
                                <option value="">Seleccionar</option>
                                <option value="1">Ecuador</option>
                                <option value="2">Colombia</option>
                            </select>
                        </div>
                    </div>

                    {/* Fecha de Nacimiento */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Fecha de Nacimiento</label>
                            <input
                                disabled
                                id="fechaNacimiento"
                                name="fechaNacimiento"
                                maxLength={50}
                                value={fechaNacimiento}
                                onChange={e => {
                                    setFechaNacimiento(e.target.value.replace(/[^a-z\s]/gi, ''))
                                    localStorage.setItem('fechaNacimiento', e.target.value.replace(/[^a-z\s]/gi, ''))
                                }}
                                type="date"
                                className="form-control"
                                placeholder="Seleccione fecha de nacimiento"
                            />
                        </div>
                    </div>

                    {/* Área */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Área</label>
                            <select disabled className="form-control">
                                <option>Seleccionar</option>
                            </select>
                        </div>
                    </div>

                    {/* Roles */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Roles</label>
                            <select disabled className="form-control">
                                <option>Seleccionar</option>
                            </select>
                        </div>
                    </div>

                    {/* Estado */}
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Estado</label>
                            <select disabled className="form-control" value={estado}>
                                <option value="">Seleccionar</option>
                                <option value="S">Activo</option>
                                <option value="N">Inactivo</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
